module.exports = __webpack_public_path__ + "img/cert1.38a6d102.png";